import { render, staticRenderFns } from "./IncomesDetails.vue?vue&type=template&id=2940629b&"
import script from "./IncomesDetails.vue?vue&type=script&lang=js&"
export * from "./IncomesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports